<template>
  <div class="item-position camera-button" :style="{left: calcPosition}">
    <template v-for="(item,index) of data">
      <div v-if="index < data.length - 1" :key="index" :class="!!item.channelStatus ? 'button m-r-20 camera_online':'button m-r-20 camera_offline'" @click="clickVideo(item)">{{item.name}}{{item.positionName}}</div>
      <div v-else :key="index" :class="!!item.channelStatus ? 'button camera_online':'button camera_offline'" @click="clickVideo(item)">{{item.name}}{{item.positionName}}</div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'Camera',
  props: {
    data: {
      type: Array
    }
  },
  computed: {
    calcPosition () {
      let beginPosition = 960
      const len = this.data.length
      const offset = len > 4 ? 240 : ((100 * len) / 2)
      beginPosition = beginPosition - offset
      return `${beginPosition}px`
    }
  },
  methods: {
    clickVideo (item) {
      this.$emit('showVideoDiv', item)
    }
  }
}
</script>

<style scoped lang="scss">
  .camera-button{
    width:460px;
    overflow: auto;
    display: flex;
    font-size: 10px;
    top:960px;
    left:810px;
    z-index:2
  }
  .button{
    width:100px;
    height:100px;
    cursor: pointer;
    text-align: center;
    padding-top: 55px;
    font-weight: bold;
    flex:none
  }
  .disabled {
    cursor: not-allowed;
    color: rgba(255,255,255,.35);
    border-color: rgba(217,217,217,.5);
    background-color: rgba(217,217,217,.5);
  }
  .camera_online {
    background-size: 100% 100%;
    background: url('/static/img/camera_online.png') center center no-repeat;
    color:#4BD0ED
  }
  .camera_offline {
    background-size: 100% 100%;
    background: url('/static/img/camera_offline.png') center center no-repeat;
    color: #BCBCBC
  }
  ::-webkit-scrollbar {
    width: 3px;
    height: 6px;
    background-color: #040b1a;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #3c3d3e;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Camera.vue